import { render, staticRenderFns } from "./CollectionTag.vue?vue&type=template&id=18104d78&"
import script from "./CollectionTag.vue?vue&type=script&lang=js&"
export * from "./CollectionTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports